import { createSelector } from '@ngrx/store';

import * as userProgramReducer from '../reducers/user-program.reducer';
import { getUserProgramState } from '../../../../app/store';

export const isUpdatingUserProgram = createSelector(
  getUserProgramState,
  userProgramReducer.userProgramUpdating
);
